<div class="requirements-container">
  <div class="row">
    <div class="col-6 col-lg-8">
      <div class="mb-3 small">Must-Haves:</div>
      <sc-requirements-editor-list [project]="project" [readonly]="readonly" [hideInvisible]="hideInvisible" priority="MustHave"
        [showCore]="isMustHaveTypeEditable" [language]="language" (onAdd)="sort(); edit();"></sc-requirements-editor-list>

      <div class="mb-3 mt-3 small">Nice-to-Haves:</div>
      <sc-requirements-editor-list [project]="project" [readonly]="readonly" [hideInvisible]="hideInvisible" priority="NiceToHave"
        [language]="language" (onAdd)="sort(); edit();"></sc-requirements-editor-list>
    </div>
    <div class="col-6 col-lg-4">
      <div class="menu-container">
        <div class="menu" [class.in]="isMenuVisible">
          <!-- Fake margin to align with tag list -->
          <div class="mb-3 small" style="opacity: 0;">Must-Haves:</div>
          <div class="card card-sm w-100">
            <div class="card-body card-body-list">

              <div class="list-group fw-normal">
                <div class="list-group-item list-group-item-action py-2 px-3 small" [class.disabled]="!canEdit"
                  (click)="edit()">
                  <span class="oneline">
                    <span class="menu-icon-wrapper">
                      <i class="fa-sharp fa-regular fa-pen"></i>
                    </span>
                    {{ texts.edit[language] }}
                  </span>
                </div>
                <div class="list-group-item list-group-item-action py-2 px-3 small"
                  [class.disabled]="!canConvertToMustHave" (click)="convertToMustHave()">
                  <span class="oneline">
                    <span class="menu-icon-wrapper">
                      <i class="fa-sharp fa-regular fa-up-from-line"></i>
                    </span>
                    {{ texts.changeToMustHave[language] }}
                  </span>
                </div>
                <div class="list-group-item list-group-item-action py-2 px-3 small"
                  [class.disabled]="!canConvertToNiceToHave" (click)="convertToNiceToHave()">
                  <span class="oneline">
                    <span class="menu-icon-wrapper">
                      <i class="fa-sharp fa-regular fa-down-to-line"></i>
                    </span>
                    {{ texts.changeToNiceToHave[language] }}
                  </span>
                </div>
                <div class="list-group-item list-group-item-action py-2 px-3 small oneline" [class.disabled]="!canJoin"
                  (click)="join()">
                  <span class="oneline">
                    <span class="menu-icon-wrapper">
                      <i class="fa-sharp fa-regular fa-merge"></i>
                    </span>
                    {{ texts.mergeOr[language] }}
                  </span>
                </div>
                <div class="list-group-item list-group-item-action py-2 px-3 small oneline" [class.disabled]="!canSplit"
                  (click)="split()">
                  <span class="oneline">
                    <span class="menu-icon-wrapper">
                      <i class="fa-sharp fa-regular fa-split"></i>
                    </span>
                    {{ texts.splitAnd[language] }}
                  </span>
                </div>
                <div class="list-group-item list-group-item-action py-2 px-3 small" [class.disabled]="!canDelete"
                  (click)="delete()">
                  <span>
                    <span class="menu-icon-wrapper">
                      <i class="fa-sharp fa-regular fa-trash"></i>
                    </span>
                    {{ texts.delete[language] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<sc-modal #editRequirementModal>
  <sc-modal-header>
    {{ texts.edit[language] }}
  </sc-modal-header>

  @if (selectedRequirement) {
  <sc-modal-body style="min-height: 40vh;">
    <div class="mb-3">

      @for (alt of selectedAlternatives; track alt; let i = $index) {
      <div class="d-flex align-items-center mb-2">
        <input type="text" [(ngModel)]="alt.value" name="alt-{{i}}" class="form-control form-control-sm me-2">
        <button (click)="removeAlternative(i)" class="btn btn-secondary btn-sm btn-circle text-danger p-0"
          [disabled]="selectedAlternatives.length === 1">
          <i class="fa-sharp fa-regular fa-trash"></i>
        </button>
      </div>
      }
      <button (click)="addAlternative()" class="btn btn-sm btn-secondary mt-2">
        <i class="fa-sharp fa-regular fa-plus me-1"></i> {{ texts.addAlternative[language] }}
      </button>
    </div>
    @if (canEditFlags) {
    <hr>
    <ng-container *ngTemplateOutlet="flagsForm"></ng-container>
    }
  </sc-modal-body>
  }

  <sc-modal-footer>
    <button class="btn-dark btn" (click)="saveRequirement()">{{ texts.ok[language] }}</button>
  </sc-modal-footer>
</sc-modal>

<sc-modal #editCustomModal>
  <sc-modal-header>
    {{ texts.edit[language] }}
  </sc-modal-header>

  @if (selectedRequirement && selectedAlternatives?.length) {
  <sc-modal-body style="height: 40vh;">
    <div class="mb-3">
      <textarea type="text" [(ngModel)]="selectedAlternatives[0].value" name="alt-{{i}}" rows="5"
        class="form-control form-control-sm me-2"></textarea>
    </div>
    @if (canEditFlags) {
    <hr>
    <ng-container *ngTemplateOutlet="flagsForm"></ng-container>
    }
  </sc-modal-body>
  }

  <sc-modal-footer>
    <button class="btn-dark btn" (click)="saveRequirement()">{{ texts.ok[language] }}</button>
  </sc-modal-footer>
</sc-modal>

<sc-modal #editExperienceModal>
  <sc-modal-header>
    {{ texts.editExperienceTitle[language] }}
  </sc-modal-header>

  @if (selectedRequirement) {
  <sc-modal-body style="height: 40vh;">
    <div class="mb-3">
      <div class="mb-2">
        <label>{{ texts.minExperience[language] }}</label>
        <input type="text" [(ngModel)]="selectedRequirement.Min" name="alt-{{i}}" type="number"
          class="form-control form-control-sm me-2">
      </div>
    </div>
    @if (canEditFlags) {
    <hr>
    <ng-container *ngTemplateOutlet="flagsForm"></ng-container>
    }
  </sc-modal-body>
  }

  <sc-modal-footer>
    <button class="btn-dark btn" (click)="editExperienceModal.dismiss(); change.next();">{{ texts.ok[language] }}</button>
  </sc-modal-footer>
</sc-modal>

<sc-modal #editLanguageModal>
  <sc-modal-header>
    {{ texts.editLanguageTitle[language] }}
  </sc-modal-header>

  @if (selectedRequirement) {
  <sc-modal-body style="height: 40vh;">
    <div class="mb-3">
      <div class="mb-2">
        <label>{{ texts.languageLabel[language] }}</label>
        <select class="form-control" [ngModel]="selectedRequirement.Alternatives[0]"
          (ngModelChange)="setLanguage(selectedRequirement, $event)">
          <option [ngValue]="'de'">{{ texts.german[language] }}</option>
          <option [ngValue]="'en'">{{ texts.english[language] }}</option>
        </select>
      </div>
      <div class="mb-2">
        <label>{{ texts.level[language] }}</label>
        <select class="form-control" [(ngModel)]="selectedRequirement.Level">
          <option [ngValue]="'Basic'">{{ texts.basic[language] }}</option>
          <option [ngValue]="'Good'">{{ texts.good[language] }}</option>
          <option [ngValue]="'Fluent'">{{ texts.fluent[language] }}</option>
        </select>
      </div>
    </div>
    @if (canEditFlags) {
    <hr>
    <ng-container *ngTemplateOutlet="flagsForm"></ng-container>
    }
  </sc-modal-body>
  }

  <sc-modal-footer>
    <button class="btn-dark btn" (click)="editLanguageModal.dismiss(); change.next();">{{ texts.ok[language] }}</button>
  </sc-modal-footer>
</sc-modal>

<!-- sc-form enables only the rows declared inside it, so the whole form lives in the template -->
<ng-template #flagsForm>
  <sc-form form="default">
    @if (canEditMustHaveType) {
    <sc-form-row [label]="texts.type[language]">
      <select class="form-control form-control-sm" [(ngModel)]="selectedRequirement.Priority">
        <option [ngValue]="'MustHave'">Must-Have</option>
        <option [ngValue]="'Core'">Core</option>
      </select>
    </sc-form-row>
    }
    <sc-form-row [label]="texts.ignore[language]">
      <select class="form-control form-control-sm" [(ngModel)]="selectedRequirement.IsDisabled">
        <option [ngValue]="false">{{ texts.no[language] }}</option>
        <option [ngValue]="true">{{ texts.yes[language] }}</option>
      </select>
    </sc-form-row>
    <sc-form-row [label]="texts.hide[language]">
      <select class="form-control form-control-sm" [(ngModel)]="selectedRequirement.IsHidden">
        <option [ngValue]="false">{{ texts.no[language] }}</option>
        <option [ngValue]="true">{{ texts.yes[language] }}</option>
      </select>
    </sc-form-row>
  </sc-form>
</ng-template>
